import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
    Container,
    Button,
    Col,
    Card,
    CardBody,
    CardTitle,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Link } from "react-router-dom"
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../components/Common/withRouter"
import PriceSelectorEditForm from "./PriceSelectorEditForm";

// Utilities
import {
    createNotificationHelpers,
    updateStoreCreatedAt,
} from "../utils";

class priceSelectorEdit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            store_domain: "",
            created_at: '',
            loading: false,
            store_details: {},
            store_status: "",
        }

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }
    formatDate = (date) => {
        const d = new Date(date);
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };
    componentDidMount() {
        const locationState = this.props.location?.state;
        const data = locationState?.data || this.props.location?.data;
        if (data && data.store_domain) {
            const { store_domain, store_details, store_status } = data;
            const created_at = this.formatDate(store_details?.created_at)
            this.setState({
                store_domain,
                created_at,
                store_details: { ...store_details },
                store_status
            });
            return;
        }
        const params = new URLSearchParams(this.props.location?.search || '');
        const storeFromQuery = params.get('store');
        if (storeFromQuery) {
            this.setState({ store_domain: storeFromQuery });
        }
    }
    /**
     * Handles form submission
     */
    handleValidSubmit = async (e) => {
        e.preventDefault();
        const { store_domain, created_at } = this.state;

        const success = await updateStoreCreatedAt(store_domain, created_at, this.notify_error);

        if (success) {
            this.setState({ loading: true });
            this.notify_success("Store info has been updated successfully!");
        }
    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    render() {
        const { store_domain, created_at, loading, store_details, store_status } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Store Info</title>
                    </Helmet>
                    <Container fluid>
                        <Breadcrumbs
                            title={("Store")}
                            breadcrumbItem={("Update Trial Info")}
                        />
                        <ToastContainer />
                        <Col md={12}>
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4"></CardTitle>
                                    <Link to={{ pathname: "/merchant-details", search: store_domain ? `?store=${encodeURIComponent(store_domain)}` : undefined, state: { data: (store_details && Object.keys(store_details).length > 0) ? store_details : { store_domain }, storeStatus: store_status } }} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>

                                        <Button className="btn btn-dark">
                                            <i className="fa fa-arrow-left"></i> Store Details
                                        </Button>
                                    </Link>

                                    <PriceSelectorEditForm
                                        store_domain={store_domain}
                                        created_at={created_at}
                                        onInputChange={this.handleInputChange}
                                        onSubmit={this.handleValidSubmit}
                                    />
                                </CardBody>
                            </Card>
                        </Col>

                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

priceSelectorEdit.propTypes = {
    t: PropTypes.any
}
export default withRouter(priceSelectorEdit)
